<template>
  <div class="travel_hlw_layout">
    <!-- 活动标题 -->
    <div v-wechat-title="'葫芦世界,扭转乾坤-时光旅行社'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-hlw' v-show='preloadingShow'>
        <div class="title"></div>
        <div class="loading_bg">

          <div class="loading">
            <div class="loading_line"></div>
          </div>
          <div class="sign"></div>
        </div>
      </div>
    </transition>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' @loginSuccess="loginSuccess" :gameName="gameName"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="false"
      noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
      @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' @reInit="reInit"
      @onOfficial="onOfficial" />
    <div :class="'super_punch_clock_page ' + (isSafari ? 'safari' : '')" ref="bg">

      <div class="index" ref="myDiv">
        <div :class="isPC ? 'border_side_pc border_side ' : 'border_side'" v-show='!preloadingShow'>
          <div class="logo"></div>
          <div class="box" :class="{ collapsed: !isExpanded }">
            <transition-group enter-active-class='animated btnFadeIn' leave-active-class='animated btnFadeOut'
              name='btn-fade'>
              <div v-for="item in btn_list" v-if="isExpanded" :class="item.className" :key="item.val"
                @click="btnClick(item)">
                {{ item.name }}</div>
            </transition-group>
          </div>
          <div @click="isExpanded = !isExpanded" :class="isExpanded ? 'up' : 'down'"></div>
        </div>
        <div class="main_01" id="#0" ref="myDiv0">
          <div class="title"></div>
          <div class="title_text"></div>
          <div class="content"></div>
          <div class="bottom"></div>
          <div class="csj"></div>
        </div>
        <div class="main_02">
          <div class="help" @click="openPopupNoAuth('ruleShow')"></div>
          <div class="title_02" id="#1" ref="myDiv1"></div>
          <div class="main_02_title"></div>
          <div class="box">
            <div class="content">
              <div class="text">累计收集葫芦<span> 1 </span>个</div>
              <div class="price main_02_01">
                <div v-if="reward_list[0]" class="active"></div>
              </div>
              <div class="price main_02_02">
                <div v-if="reward_list[0]" class="active"></div>
              </div>
              <div :class="package_list[0].status ? 'btn_active' : 'btn'">{{ package_list[0].status ? '已完成' : '未完成' }}
              </div>
            </div>
            <div class="content">
              <div class="text">累计收集葫芦<span> 4 </span>个</div>
              <div class="price main_02_03">
                <div v-if="reward_list[1]" class="active"></div>
              </div>
              <div class="price main_02_02">
                <div v-if="reward_list[1]" class="active"></div>
              </div>
              <div :class="package_list[1].status ? 'btn_active' : 'btn'">{{ package_list[1].status ? '已完成' : '未完成' }}
              </div>
            </div>
            <div class="content">
              <div class="text">累计收集葫芦<span> 7 </span>个</div>
              <div class="price main_02_04">
                <div v-if="reward_list[2]" class="active"></div>
              </div>
              <div class="price main_02_05">
                <div v-if="reward_list[2]" class="active"></div>
              </div>
              <div :class="package_list[2].status ? 'btn_active' : 'btn'">{{ package_list[2].status ? '已完成' : '未完成' }}
              </div>
            </div>
          </div>
          <div class="text_title">
            <div class="text_title_text"> &nbsp;&nbsp;当前葫芦数：<span>{{ that_person_heat }}</span></div>
          </div>
          <div class="text_box">
            <div class="text_box_item">
              <div class="sign"></div>
              <div class="text">参与预热，葫芦<span> +1</span></div>
              <div class="btn" @click="doneTask(1)">
                {{ task_list[0].status ? '已完成' : '点击预热' }}
              </div>
            </div>

            <div class="text_box_item">
              <div class="sign"></div>
              <div class="text">添加官方交流群，葫芦<span> +3</span></div>
              <div class="btn" @click="doneTask(2)">
                {{ task_list[1].status ? '已完成' : '点击添加' }}
              </div>
            </div>

            <div class="text_box_item">
              <div class="sign"></div>
              <div class="text">邀请好友助力，葫芦<span> +1</span><span class="help_num">({{ help_count }}/3)</span></div>
              <a class="btn" id="my-code" href="javascript:;" @click="onCopy('#my-code')"
                :data-clipboard-text='"《时光旅行社》联动童年回忆《葫芦兄弟》，新世界之子——二娃即将登场，点击链接参加预热活动：" + shareLink'>
                {{ task_list[2].status ? '已完成' : '立即邀请' }}
              </a>
            </div>
          </div>
        </div>
        <div class="main_03">
          <div class="help" @click="openPopupNoAuth('ruleShow1')"></div>
          <div class="main_03_title"></div>
          <div class="main_03_text"></div>
          <div class="price_box">

            <div class="price_box_item">
              <div v-if="reward_list[3]" class="active"></div>
            </div>
            <div class="price_box_item">
              <div v-if="reward_list[4]" class="active"></div>
            </div>
            <div class="price_box_item">
              <div v-if="reward_list[5]" class="active"></div>
            </div>
          </div>
          <div class="bottom_text">当前全服葫芦数：<span>
              {{ hotNum }}
            </span></div>
          <div class="bottom"></div>
        </div>
        <div class="main_04">
          <div :class="taskStateClass" @click="getReward">
            <div class="main_04_state_title">
              {{ taskState }}</div>
            <div v-if="taskStateClass === 'main_04_state_disabled'" class="main_04_state_text">2月7日 10:00后开放领取</div>
            <div v-else class="main_04_state_text">每档奖励仅可领取一次</div>
          </div>
          <div class="fourth_baby"></div>
          <div class="main_04_box">
            <div class="title_03" id="#2" ref="myDiv2"></div>
            <div class="main_04_box_content"></div>
            <div class="main_04_price_box">
              <div class="main_04_price_box_title"></div>
              <div class="main_04_price_box_content">
                <div class="main_04_price_box_item"></div>
                <div class="main_04_price_box_item"></div>
              </div>
            </div>
          </div>
          <div class="light"></div>
          <div class="second_baby"></div>
        </div>
        <div class="main_05">
          <div class="main_05_title"></div>
          <div class="swiper_box">
            <!-- 设置左右切换按钮 -->
            <div class="swiper-button-next3 ani-btn arrow"></div>
            <div class="swiper-button-prev3 ani-btn arrow"></div>
            <div class="swiper-container " ref="mySwiper">
              <div class="swiper-wrapper">
                <!-- 插入你的轮播内容 -->
                <div class="swiper-slide" v-for="(item, index) in mdv" :key="index">
                  <img :src="item.photo" alt="" />
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
        <div class="main_06">
          <div class="logo"></div>
          <div class="main_06_bottom"></div>
        </div>

      </div>
      <div class="foot-page">
        <Footer :gameName="gameName" />
      </div>
    </div>

    <!-- 微信下载 -->
    <div class="wx_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="closePopup('wxLoadShow')"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="closePopup('wxLoadShow')"></div>
    </div>

    <!-- 信息列表 -->
    <div class="rule_wrap popup_wrap" v-show="messageShow" @click="closePopup('messageShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="messageImg" alt="详情">
          </div>
          <div class="baby"> </div>
        </div>
      </transition>
    </div>

    <!-- 奖励领取列表 -->
    <div class="price_wrap popup_wrap" v-show="priceShow" @click="closePopup('priceShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail" v-if="!rewardSum">
            <div class="price_text">奖励仅可领取一次，当前将领到
              <span> {{ this.userInfo.server_name }}</span>
              服 <span>{{ this.userInfo.role_name }}</span>角色
            </div>
          </div>
          <div v-else class="detail">
            <div class="price_text">已成功领取到
              <span> {{ this.userInfo.server_name }}</span>
              服 <span>{{ this.userInfo.role_name }}</span>角色
            </div>
          </div>
          <div class="baby"> </div>
          <div v-if="!rewardSum" class="price_btn" @click="reward()">点击领取</div>
          <div class="close_btn" @click="closePopup('priceShow')"></div>
        </div>
      </transition>
    </div>

    <!-- 助力列表 -->
    <div class="help_wrap popup_wrap" v-show="helpShow" @click="closePopup('helpShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail"> </div>
          <div class="baby"> </div>
          <div class="help_btn" @click="invite(3)"></div>
          <div class="close_btn" @click="closePopup('helpShow')"></div>
        </div>
      </transition>
    </div>

    <!-- 规则列表 -->
    <div class="rule_wrap popup_wrap" v-show="ruleShow" @click="closePopup('ruleShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/assets/images/active/travel/hlw/06/rule.png" alt="详情"></img>
          </div>
          <div class="baby"> </div>
          <div class="close_btn" @click="closePopup('ruleShow')"></div>
        </div>
      </transition>
    </div>

    <div class="rule_wrap popup_wrap" v-show="ruleShow1" @click="closePopup('ruleShow1')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="ruleShow1">
        <div class="detail_box" v-show="ruleShow1">
          <div class="detail">
            <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/assets/images/active/travel/hlw/06/rule1.png" alt="详情">
          </div>
          <div class="baby"> </div>
          <div class="close_btn" @click="closePopup('ruleShow1')"></div>
        </div>
      </transition>
    </div>

    <div class="rule_wrap popup_wrap" v-show="codeShow" @click="closePopup('codeShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="codeShow">
        <div class="detail_box" v-show="codeShow">
          <div class="detail">
            <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/assets/images/active/travel/hlw/06/code.png" alt="详情">
          </div>
          <div class="baby"> </div>
          <div class="close_btn" @click="closePopup('codeShow')"></div>
        </div>
      </transition>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '../Header/index.vue';
import Footer from "@/components/Footer";
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI, hotNum, reward, task, invite } from '../api';
import { getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Clipboard from 'clipboard';
// import eruda from 'eruda';

export default {
  name: 'demo',
  components: {
    Header,
    Login,
    Os,
    swiper,
    swiperSlide,
    Footer
  },
  data() {
    return {
      headerConfig,
      gameName: 'travel',
      is_access_token: '',
      downloadUrl: 'https://sglxs.qingcitimes.com/',
      loginTypes: ["sms", "password"],
      preloadingShow: true,
      titleShow: true,
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      isSafari: false,
      mdv: [
        {
          photo: 'https://download4.qcplay.com/h5-images/active/travel/hlw/05/1.png',
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/travel/hlw/05/2.png',
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/travel/hlw/05/3.png',
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/travel/hlw/05/4.png',
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/travel/hlw/05/5.png',
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/travel/hlw/05/6.png',
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/travel/hlw/05/7.png',
        },
      ],
      help_error: 'https://download4.qcplay.com/h5-images/active/travel/hlw//06/help_error.png',
      help_error1: 'https://download4.qcplay.com/h5-images/active/travel/hlw//06/help_error1.png',
      help_error2: 'https://download4.qcplay.com/h5-images/active/travel/hlw//06/help_error2.png',
      help_success: 'https://download4.qcplay.com/h5-images/active/travel/hlw//06/help_success.png',
      help_error_401: 'https://download4.qcplay.com/h5-images/active/travel/hlw//06/401.png',
      help_error_404: 'https://download4.qcplay.com/h5-images/active/travel/hlw//06/404.png',
      help_error_405: 'https://download4.qcplay.com/h5-images/active/travel/hlw//06/405.png',
      help_error_406: 'https://download4.qcplay.com/h5-images/active/travel/hlw//06/406.png',
      success: 'https://download4.qcplay.com/h5-images/active/travel/hlw//06/success.png',
      success1: 'https://download4.qcplay.com/h5-images/active/travel/hlw//06/success1.png',
      messageImg: '',
      isPC: false,
      selectInfo: {},

      btn_list: [
        { name: '葫芦乾坤', val: '#0', className: 'btn_click' },
        { name: '赛季预热', val: '#1', className: 'btn' },
        { name: '年兽来袭', val: '#2', className: 'btn' },
      ],
      isExpanded: true,
      ruleShow: false,
      ruleShow1: false,
      helpShow: false,
      priceShow: false,
      helpSign: false,
      codeShow: false,
      messageShow: false,
      wxLoadShow: false,
      isUserInfo: false,
      package_list: [
        {
          "id": 1,
          "name": "\u7d2f\u8ba1\u6536\u96c6\u846b\u82a6*1",
          "status": 0,
          "num": 1
        },
        {
          "id": 2,
          "name": "\u7d2f\u8ba1\u6536\u96c6\u846b\u82a6*5",
          "status": 0,
          "num": 5
        },
        {
          "id": 3,
          "name": "\u7d2f\u8ba1\u6536\u96c6\u846b\u82a6*10",
          "status": 0,
          "num": 10
        }
      ],
      reward_list: [
        0,
        0,
        0,
        0,
        0,
        0
      ],
      help_count: 0,
      task_list: [{
        "id": 1,
        "name": "\u53c2\u4e0e\u9884\u70ed\uff0c\u846b\u82a6\u6570+1",
        "status": 0,
        "num": 1
      },
      {
        "id": 2,
        "name": "\u6dfb\u52a0\u5b98\u670d\u4ea4\u6d41\u7fa4,\u846b\u82a6\u6570+1",
        "status": 0,
        "num": 1
      },
      {
        "id": 3,
        "name": "\u6bcf\u65e5\u9080\u8bf7\u597d\u53cb\u52a9\u529b,\u846b\u82a6\u6570+1",
        "status": 0,
        "num": 3
      }],
      hotNum: 0,
      that_person_heat: 0,
      shareLink: '',
      user_info: {},
      taskState: '已领取',
      taskStateClass: 'main_04_state_disabled',
      observer: null,
      loopInt: null,
      rewardSum: 0
    };
  },
  created() {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    this.isWechatBrowser = wechatBrowser();
    if (this.isWechatBrowser) { // 在微信app下

    } else {
      // safari下底部被遮住
      if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
        this.isSafari = true;
      }
    }

    // 埋点
    const bl = buriedLogger('travel', '时光葫芦世界');
    this.logger = bl;
    this.messageImg = null
    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/travel/invitation/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };
    this.getUserInfo()


    var userAgent = navigator.userAgent.toLowerCase();
    this.isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;

    if (this.isPC) {

      console.log(this.isPC, '当前设备是 PC');
    } else {
      console.log('当前设备不是 PC');
    }

    this.getHotNum()


    function getTimestampForDate(year, month, day, hour) {
      const dateObj = new Date(year, month - 1, day, hour);
      const timestamp = dateObj.getTime();

      return timestamp;
    }
    function getCurrentTimestamp() {
      const dateObj = new Date();
      const timestamp = dateObj.getTime();

      return timestamp;
    }

    // 使用示例
    const year = 2024; // 年份
    const month = 2; // 月份，2表示二月
    const day = 7; // 日期
    const hour = 10; // 小时
    const timestamp = getTimestampForDate(year, month, day, hour)
    const currentTimeStamp = getCurrentTimestamp()
    if (timestamp <= currentTimeStamp) {
      console.log('指定日期时间已过');
      this.taskState = '待领取'
      this.taskStateClass = 'main_04_state'
    } else {
      console.log('指定日期时间');
      this.taskState = '待领取'
      this.taskStateClass = 'main_04_state_disabled'
    }
  },
  mounted() {
    this.observeElement();
    this.swiperInit()
    window.addEventListener('resize', this.swiperInit);
    // let el = document.createElement('div');
    // document.body.appendChild(el);

    // eruda.init({
    //   container: el,
    //   useShadowDom: true
    // });

  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        console.log('oldValue------>', oldValue)
        console.log('newValue------>', newValue)
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {

            if (!newValue.account) {
              // TAG: 注销的时候
              // this.clearActiveInfo();
              this.reInit()
            } else {
              console.log('登录成功')
              this.getUserInfo()
            }
          }
        }

      }
    },
  },
  beforeDestroy() {
    this.observer.unobserve(this.$refs.myDiv1);
    this.observer.unobserve(this.$refs.myDiv2);
    this.observer.unobserve(this.$refs.myDiv0);
  },
  methods: {
    swiperInit() {
      console.log('swiperInit')
      var swiper = new Swiper('.swiper-container', {
        loop: true,
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        nextButton: '.next',
        prevButton: '.prev',
        spaceBetween: '0%',
        slidesPerView: 'auto',
        autoplayDisableOnInteraction: false,
        // autoplay: 2000,
        prevButton: '.swiper-button-prev3',
        nextButton: '.swiper-button-next3',
        pagination: '.swiper-pagination',
        coverflow: {
          rotate: 0, // 旋转的角度
          stretch: 10, // 拉伸   图片间左右的间距和密集度
          depth: 30, // 深度   切换图片间上下的间距和密集度
          modifier: 6.6, // 修正值 该值越大前面的效果越明显
          slideShadows: false
        },
      });
    },
    observeElement() {
      const options = {
        root: null, // relative to document viewport
        rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: 0,  // 目标元素完全进入或离开视口中间位置时触发回调
      };

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          console.log(this)
          if (entry.isIntersecting) {
            console.log(entry)
            const index = entry.target.id[1]
            const btn_list = document.querySelectorAll(".border_side .box")[0].children[0].childNodes
            if (this.isExpanded) {
              for (let i = 0; i < 3; i++) {
                if (i == index) {
                  btn_list[i].className = "btn_click"
                } else {
                  btn_list[i].className = "btn"
                }
              }
            } else {
              for (let i = 0; i < this.btn_list.length; i++) {
                if (i == index) {
                  this.btn_list[i].className = "btn_click"
                } else {
                  this.btn_list[i].className = "btn"
                }
              }
            }


            console.log('div is visible');
          } else {
            console.log('div is not visible');
          }
        });
      }, options);

      this.observer.observe(this.$refs.myDiv1);
      this.observer.observe(this.$refs.myDiv2);
      this.observer.observe(this.$refs.myDiv0);
    },
    invite() {
      const params = {
        code: this.$route.query.code
      }
      invite(params).then(res => {
        console.log(res)
        this.messageImg = null
        if (res.code === 200) {
          this.messageImg = this.help_success
          this.messageShow = true
        }
        else if (res.code === 401) {
          this.messageImg = this.help_error_401
          this.messageShow = true

        }
        else if (res.code === 402) {
          this.messageImg = this.help_error1
          this.messageShow = true

        }
        else if (res.code === 404) {
          this.messageImg = this.help_error_404
          this.messageShow = true

        }
        else if (res.code === 405) {
          this.messageImg = this.help_error_405
          this.messageShow = true

        }
        else if (res.code === 406) {
          this.messageImg = this.help_error_406
          this.messageShow = true
        }
        else if (res.code === 407) {
          this.messageImg = this.help_error
          this.messageShow = true
        } else {
          this.onToast(res.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    doneTask(index) {
      console.log(index)

      if (!this.userInfo.account) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');

      }
      const that = this
      const params = {
        task_id: index
      }
      task(params).then((res) => {
        console.log(res)
        this.messageText = res.message
        this.messageImg = null

        if (index == 1) {
          this.logger.sum('时光旅行社_葫芦世界_任务一，参与预热');
          if (res.code === 200) {
            this.getUserInfo()
            this.messageImg = this.success1
            this.messageShow = true
          } else {
            this.messageShow = false
            this.onToast(res.message)
          }
        }
        if (index == 3) {
          this.logger.sum('时光旅行社_葫芦世界_任务三，好友助力');
          if (res.code === 401) {
            this.messageImg = this.help_error_401
            this.messageShow = true
          }
          else if (res.code === 401) {
            this.messageImg = this.help_error_401
            this.messageShow = true
          }
          else if (res.code === 402) {
            this.messageImg = this.help_error1
            this.messageShow = true
          }
          else if (res.code === 404) {
            this.messageImg = this.help_error_404
            this.messageShow = true
          }
          else if (res.code === 405) {
            this.messageImg = this.help_error_405
            this.messageShow = true
          }
          else if (res.code === 406) {
            this.messageImg = this.help_error_406
            this.messageShow = true
          }
          else if (res.code === 407) {
            this.messageImg = this.help_error
            this.messageShow = true
          } else {
            this.messageShow = false
            this.onToast(res.message)
          }
        }
        if (index == 2) {
          this.logger.sum('时光旅行社_葫芦世界_任务二，官方加群');
          if (res.code === 200) {
            this.getUserInfo()
            this.messageImg = this.success1
            this.messageShow = true
          }
          else if (res.code === 405) {
            this.logger.sum('时光旅行社_葫芦世界_添加官方交流群');
            if (that.task_list[1].status) {
              that.codeShow = true
            } else {
              this.logger.sum('时光旅行社_葫芦世界_点击前往小程序wiki');
              localStorage.setItem("open_link", res.data.open_link);
              document.onvisibilitychange = function () {
                if (document.visibilityState == 'visible') {
                  that.logger.sum('时光旅行社_葫芦世界_小程序返回活动页');
                  console.log('切回应用');
                  that.getUserInfo()
                  that.loopInt = setInterval(function () {
                    console.log('检测是否返回应用');
                    that.getUserInfo()
                  }, 1000)
                  setTimeout(function () {
                    console.log('清除定时器');
                    clearInterval(that.loopInt)
                  }, 15000)
                }
              };
              window.location.href = res.data.open_link
            }
          } else {
            this.messageShow = false
            this.onToast(res.message)
          }
        }

      })
    },
    getReward() {
      function throttle(func, delay) {
        let timeoutId;

        return function () {
          if (!timeoutId) {
            timeoutId = setTimeout(() => {
              func.apply(this, arguments);
              timeoutId = null;
            }, delay);
          }
        };
      }
      if (!this.isUserInfo) {
        console.log('请先登录')
        throttle(this.changeLoginPopup(true), 1000)
        return this.onToast('很抱歉，请先登录');
      }

      console.log(this.userInfo, '领取奖励')
      if (this.taskStateClass == 'main_04_state_disabled') {
        return this.onToast('2月7日 10:00后开放领取')
      }
      if (!this.userInfo.hasOwnProperty('role_id')) {
        console.log('选择角色')
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!this.userInfo.role_id) {
        console.log('选择角色')
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!this.userInfo.role_id.length) {
        console.log('选择角色')
        throttle(this.changeOsPopup(true), 1000)
        return
      }
      this.rewardSum = this.reward_list.reduce((accumulator, currentValue) => accumulator + currentValue, 0)
      if (this.rewardSum <= 0) {
        console.log('再次选择角色')
        throttle(this.changeOsPopup(true), 1000)
        return
      }
      console.log(this.rewardSum, 'this.rewardSum')
      if (this.rewardSum >= 6) {
        this.onToast('您已领取所有奖励')
      } else {
        const params = { ...this.userInfo }
        reward(params).then(res => {
          this.logger.sum('时光旅行社_葫芦世界_领取奖励');
          console.log('res------>', res)
          if (res.code === 200) {
            this.priceShow = true
            this.getUserInfo()
          } else {
            this.priceShow = false
            this.onToast(res.message)
          }
        })

      }

    },
    reward() {
      this.priceShow = false
      const params = { ...this.userInfo }
      function throttle(func, delay) {
        let timeoutId;

        return function () {
          if (!timeoutId) {
            timeoutId = setTimeout(() => {
              func.apply(this, arguments);
              timeoutId = null;
            }, delay);
          }
        };
      }
      throttle(reward(params).then(res => {
        this.logger.sum('时光旅行社_葫芦世界_领取奖励');
        console.log('res------>', res)
        if (res.code === 200) {
          this.messageImg = null
          this.messageImg = this.success
          this.messageShow = true
          this.getUserInfo()
        } else {
          this.messageShow = false
          this.onToast(res.message)
        }
      }), 1000)

    },

    scrollToElement(target) {
      const element = document.getElementById(target); // 获取目标元素
      element.scrollIntoView({
        behavior: 'smooth' // 使用平滑滚动效果（可选）
      });
    },
    btnClick(res) {
      if (res.className == 'btn_click') return
      this.btn_list.forEach((ele, index) => {
        if (res.val == ele.val) {
          ele.className = 'btn_click'
        } else {
          ele.className = 'btn'
        }
      })
      this.$set(this, 'btn_list', this.btn_list)
      this.scrollToElement(res.val)
    },

    // 复制链接
    onCopy(my_id) {
      if (!this.userInfo.account) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');

      }

      this.logger.sum('时光旅行社_葫芦世界_复制链接邀请好友');
      const clipboard = new Clipboard(my_id);
      console.log(clipboard, 'clipboard')
      clipboard.on('success', (e) => {
        console.log(clipboard, 'success')
        this.onToast('邀请链接复制成功，快快发送给你的好友吧~');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        console.log(clipboard, 'error')
        this.onToast('复制失败');
      });
    },

    initShareData() {
      try {
        const { protocol, host } = window.location;
        this.shareLink = `${protocol}//${host}/travel/hlw/help${getRandomString()}?code=` + this.user_info.code;
        this.$set(this, 'shareLink', this.shareLink)
        console.log('shareLink', this.shareLink);
        this.isSetShare(this.shareLink);
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    getHotNum() {
      hotNum().then(response => {
        this.hotNum = response.data.heat;
      })
    },
    // 获取用户信息
    async getUserInfo() {
      const that = this
      await onGetInitDataAPI().then(response => {
        that.preloadingShow = false;
        if (response.code === 200) {
          that.package_list = response.data.activity.package_list
          this.help_count = response.data.activity.help_count
          that.task_list = response.data.activity.task_list
          that.that_person_heat = response.data.activity.that_person_heat
          that.user_info = response.data.userinfo;
          that.taskState = '已领取'
          that.reward_list = response.data.activity.reward_list
          response.data.activity.reward_list.forEach(ele => {
            if (!ele) {
              that.taskState = '待领取'
            }
          })
          if (that.loopInt && response.data.activity.task_list[1]) {
            console.log('清除定时器')
            clearIntervall(this.loopInt)
          }
          that.isUserInfo = true
          that.getHotNum()
          that.initShareData();
          that.onInitState(response);
          if (that.$route.fullPath.indexOf('help') > -1 && that.helpSign === false) {
            this.logger.sum('时光旅行社_葫芦世界_好友加入助力');
            that.helpShow = true
            that.helpSign = true
          }
          // 例如：获取好友助力信息等
        } else {
          that.isUserInfo = false
          that.onToast(response.message);
          that.setInitUserInfo();
          that.setInitActiveInfo();
        }
      }).catch(() => {
        that.preloadingShow = false;
      }).finally(() => {
        document.onvisibilitychange = null
      })
    },


    onInitState(response) {
      const { code } = response || {}
      if (response.code == 200) {
        console.log('初始化数据成功');
        this.setUserInfo(response.data.userinfo);
      }
      // 很抱歉，请先登录！
      if (response.code == 403) {
        this.changeLoginPopup(true);
      }
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.isUserInfo = false; // 是否获取到用户信息，用于判断是否显示登录弹窗等
      this.isLogin = false; // 是否登录，用于判断是否显示登录弹窗等
      this.isSelectRole = false; // 是否选择角色，用于判断是否显示选择角色弹窗等
      this.isSelectServer = false; // 是否选择服务器，用于判断是否显示选择服务器弹窗等
      this.help_count = 0; // 助力次数
      this.that_person_heat = 0
      this.taskState = '待领取'
      this.helpSign = false

      this.package_list = [
        {
          "id": 1,
          "name": "\u7d2f\u8ba1\u6536\u96c6\u846b\u82a6*1",
          "status": 0,
          "num": 1
        },
        {
          "id": 2,
          "name": "\u7d2f\u8ba1\u6536\u96c6\u846b\u82a6*5",
          "status": 0,
          "num": 5
        },
        {
          "id": 3,
          "name": "\u7d2f\u8ba1\u6536\u96c6\u846b\u82a6*10",
          "status": 0,
          "num": 10
        }
      ]
      this.task_list = [{
        "id": 1,
        "name": "\u53c2\u4e0e\u9884\u70ed\uff0c\u846b\u82a6\u6570+1",
        "status": 0,
        "num": 1
      },
      {
        "id": 2,
        "name": "\u6dfb\u52a0\u5b98\u670d\u4ea4\u6d41\u7fa4,\u846b\u82a6\u6570+1",
        "status": 0,
        "num": 1
      },
      {
        "id": 3,
        "name": "\u6bcf\u65e5\u9080\u8bf7\u597d\u53cb\u52a9\u529b,\u846b\u82a6\u6570+1",
        "status": 0,
        "num": 3
      }] // 任务列表，用于展示任务列表，包括任务名称、状态、奖励数量等

      this.reward_list = [
        0,
        0,
        0,
        0,
        0,
        0
      ]
      this.$set(this, 'package_list', this.package_list)
      this.$set(this, 'reward_list', this.reward_list)
      this.$set(this, 'task_list', this.task_list)
      this.setInitUserInfo();
      this.setInitActiveInfo();
      console.log(this.userInfo, '注销')
    },
    LoginCallBack() {
      console.log(arguments, '登录回调')
    },
    // 选择角色后
    selectCallback() {
      // 初始化
      this.priceShow = true
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo
      selectInfo.account = this.userInfo.account
      this.setUserInfo(selectInfo);
      console.log(this.selectInfo, '选择角色信息')
    },
    loginSuccess() {
      this.getUserInfo()
    },
    reInit() {
      console.log('清除data里面相关数据')
      this.clearActiveInfo(); // 清除data里面相关数据
    },
    onOfficial() {
      this.isWechatBrowser = wechatBrowser();
      if (this.isWechatBrowser) { // 在微信app下
        console.log('在微信app下');
        return this.wxLoadShow = true
      }
      this.logger.sum('时光旅行社_葫芦世界_，前往下载');
    },
    // 区组弹窗注销-相关参数复位
    osCancell() { },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },


    // TAG: 其他简易封装的方法
    openPopupNoAuth(name) {
      console.log('openPopupNoAuth', name);
      if (name == 'ruleShow') {
        this.logger.sum('时光葫芦娃新年活动，规则1');
      }

      if (name == 'ruleShow1') {
        this.logger.sum('时光葫芦娃新年活动，规则2');
      }
      this[name] = true;
    },
    // TAG: 其他简易封装的方法
    openPopup(name) {
      if (!this.isUserInfo) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }


      if (name == 'codeShow') {
        this.logger.sum('时光葫芦娃新年活动，打开二维码');
        this.doneTask(2)
      }
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/travel/hlw/enter${getRandomString()}`,
        title: '时光旅行社×葫芦兄弟联动开启！',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/1pUYeFwaTwTKbZjHTYJD36PAmoxyskQUJbYH1t00.png',
        desc: '童年回忆葫芦兄弟，降临时光旅行社，参与活动集葫芦得星石、神眷等好礼'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/travel/hlw/index/index.vue